import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.action.DOC}
  query MosaicAction(
    $tenantId: ID!
    $zoneId: ID!
    $actionIdentifier: FlexibleIdentifierInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          action(identifier: $actionIdentifier) {
            ...FragmentMosaicAction
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.MosaicActionQuery,
  ents.core.mosaic.Action | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'mosaicDev',
      graphql.transformers.OUT.select('action', fragments.action.TRANSFORMER),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.MosaicActionQuery,
  ents.core.mosaic.Action | undefined,
  graphql.schema.MosaicActionQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
